module.exports = __webpack_public_path__ + "static/RivieraNights-Bold-7b58f1830741cfcb078c74d9e09dc25c.woff";